import {imageUrl, templateURI} from "./app";

window.addEventListener('DOMContentLoaded', (event) => {

    //change language
    $('.lang-btn').click(function (event) {
        let lang = event.target.getAttribute('data-lang')
        let current = event.target.getAttribute('data-current')
        let def = event.target.getAttribute('data-default')
        let path = window.location.pathname
        const words = path.split('/')
        words.shift()
        words.pop()
        if (lang !== current) {
            if (lang !== def) {
                if (words[0] !== 'en' || words[0] !== 'ja') {
                    words.unshift(lang)
                }
                window.location.pathname = words.join('/')
            } else {
                if (words[0] === 'en' || words[0] === 'ja') {
                    words.shift()
                }
                window.location.pathname = words.join('/')
            }
        }
    })


    $('#toggle').click(function () {
        $('#shadow').toggleClass('active')
    });

    const eventToggle = $('.event-toggle');
    if (eventToggle) {
        eventToggle.click(function () {
            $(this).siblings('.list-item').slideToggle()
            if ($(this).children('.icon-toggle').hasClass('active')) {
                $(this).children('.icon-toggle').html('✛')
            } else {
                $(this).children('.icon-toggle').html('⚊')
            }
            $(this).children('.icon-toggle').toggleClass('active')
        });

        // setTimeout(() => {
        //     eventToggle.eq(0).trigger("click");
        // }, 10)

    }


    $('.icon-search').click(function () {
        $(this).parents('.form-search-header').addClass('active')
        // $(this).attr('type', 'submit')
    });
    $('.icon-toggle-search-header').click(function () {
        $(this).siblings('.box-search-header').slideToggle()
        $(this).siblings('.box-search-header').toggleClass('active')
        $(this).children('img')
            .attr('src', (_, attr) => attr == templateURI('resources/com/icon/search.svg') ?
                templateURI('resources/images/close.png') : templateURI('resources/com/icon/search.svg'))
    })
    $('.load-more').click(function (event) {
        let offset = $(".content-count").children().length;
        const perPage = event.target.getAttribute('data-perPage')
        const tag = event.target.getAttribute('data-tag')
        const category = event.target.getAttribute('data-category')
        const searchString = event.target.getAttribute('data-search-string')
        const displayType = event.target.getAttribute('data-display-type')
        const postType = event.target.getAttribute('data-post-type')
        const btn = $(this)
        const text = btn.text()
        const loadingHtml = `<img class="image" style="height: 32px" src="${templateURI('resources/com/loading.svg')}">`
        $.ajax({
            type: "post",
            dataType: 'json',
            async: false,
            url: "/wp-admin/admin-ajax.php",
            data: {
                action: "loadmore",
                offset: offset,
                tag: tag,
                cat: category,
                searchString: searchString ? searchString : null,
                display: displayType,
                postType: postType
            },
            beforeSend: function () {
                btn.html(loadingHtml)
            },
            success: function (response) {
                offset = offset + parseInt(perPage);
                $('.content-count').append(response.html)
                const equipmentEle = document.getElementById("modal-equipment-detail");

                if (equipmentEle) {
                    var equipmentID = null
                    var category = null
                    var postType = null
                    var equipmentModal = new bootstrap.Modal(equipmentEle, {})


                    setTimeout(() => {
                        $(".equipment-image").off('click').on('click', function (event) {
                            event.preventDefault();
                            const $target = $(this)
                            equipmentID = $target.data('equipment')
                            category = $target.data('category')
                            postType = $target.data('post-type')
                            console.log(category, postType)
                            if (category && postType) {
                                $(equipmentEle).find('.modal-content').html('読み込んでいます...')

                                equipmentModal.show()
                            }
                        })
                        equipmentEle.addEventListener('shown.bs.modal', () => {
                            if (category && postType)
                                $.ajax({
                                    type: "post",
                                    dataType: 'json',
                                    async: true,
                                    url: "/wp-admin/admin-ajax.php",
                                    data: {
                                        action: "getEquipment",
                                        id: equipmentID,
                                        category: category,
                                        postType: postType
                                    },
                                    beforeSend: function () {

                                    },
                                    success: function (response) {
                                        $(equipmentEle).find('.modal-content').html(response.html)
                                    },
                                    error: function (jqXHR, textStatus, errorThrown) {
                                    }
                                })
                        })
                    }, 100)


                }
                if (response.max * perPage === offset) {
                    btn.hide()
                }

                btn.html(text)
            },
            error: function (jqXHR, textStatus, errorThrown) {
                btn.html(text)
                btn.show()
            }
        });
    });

//
    $('.more-tab').click(function () {
        $(this).siblings('.nav-pills').toggleClass('active')
        $(this).siblings('.box-nav').toggleClass('active')
        $(this).parents('.wrap-tabs').toggleClass('active')
        $(this).toggleClass('active')
    })
    //
    let widthBox = $(".box-tabs-main .nav-item")
    let widthMain = $(".box-tabs-main").outerWidth()
    let iWidth = 0
    for (let i = 0; i < widthBox.length; i++) {
        iWidth += $(widthBox[i]).outerWidth();
    }
    // if(iWidth < widthMain){
    //     $(".box-tabs-main .more-tab").css('display', 'none')
    // } else {
    //     $(".box-tabs-main .more-tab").css('display', 'block')
    // }

    $(document).mouseup(function (e) {
        let container = $(".form-search-header.d-lg-none");
        if (!container.is(e.target) &&
            container.has(e.target).length === 0) {
            $(".form-search-header.d-lg-none").removeClass('active');
        }
    });
    //
    $(".toggle-item-menu").click(function () {
        $(this).siblings('.mega-menu').slideToggle()
        $(this).toggleClass('active')
    })
    $('.toggle-menu').click(function () {
        $(this).toggleClass("active")
        $(".menu-header").toggleClass("active")
        $("body").toggleClass("active-menu")
        // let heightHeader = $("#header").height()
        // $(".menu-header").css('top', heightHeader + 'px')
    })
    new ResizeObserver(() => {
        const widthBody = document.querySelector('body').offsetWidth;
        let heightHeader = $("#header").height()
        if (widthBody > 1024) {
            $(".menu-header").css('top', '0px')
        } else {
            $(".menu-header").css('top', heightHeader + 'px')
        }
    }).observe(document.body)
    $(document).mouseup(function (e) {
        let container = $("#header");
        if (!container.is(e.target) &&
            container.has(e.target).length === 0) {
            $(".toggle-menu").removeClass("active")
            $(".menu-header").removeClass("active")
            $("body").removeClass("active-menu")
        }
    });


    $('#slide-top').owlCarousel({
        loop: true,
        autoplay: true,
        autoplayTimeout: 7000,
        margin: 24,
        responsive: {
            0: {
                items: 1,
                margin: 16
            },
            576: {
                items: 2,
            },

        }
    });
    $('#slider-topics-main').owlCarousel({
        loop: true,
        autoplay: true,
        autoplayTimeout: 7000,
        margin: 24,
        responsive: {
            0: {
                items: 1,
            },
        }
    });
    if ($('#slide-same') && $('#slide-same').hasClass("owl-carousel")) {
        $('#slide-same').owlCarousel({
            loop: false,
            // autoplay: true,
            // autoplayTimeout: 7000,
            margin: 30,
            nav: true,
            navText: [`<div class="btn-nav nav-prev">前のTopic</div>`, `<div class="btn-nav nav-next">次のTopic</div>`],
            responsive: {
                0: {
                    items: 2,
                    margin: 20,
                },
                576: {
                    items: 2,
                },
            }
        });
    }



// scroll top
    $('.scroll-top').click(function () {
        $('html, body').animate({
            scrollTop: 0
        }, 400)
    });
    let offset = 800,
        $back_to_top = $('.scroll-top');
    $(window).scroll(function () {
        ($(this).scrollTop() > offset) ? $back_to_top.addClass('visible-top') : $back_to_top.removeClass('visible-top');
    });

    //
    function fixScrollHeader() {
        let prevScroll = window.pageYOffset;
        let heightHeader = $("#header").height()
        window.onscroll = function () {
            let currentScrollPos = window.pageYOffset;
            if (prevScroll > currentScrollPos) {
                $("#header").css({
                    "position": "sticky",
                    "top": 0,
                });
                $("#header").addClass('active');
            } else {
                $("#header").css({
                    "top": "-" + heightHeader + "px",
                });
                $("#header").removeClass('active');
                if ($('.box-search-header').hasClass('active')) {
                    $('.box-search-header').removeClass('active')
                    $('.icon-toggle-search-header').children('img').attr('src', templateURI('resources/images/icon-search.png'))
                    $('.box-search-header').slideToggle()
                }
            }
            prevScroll = currentScrollPos;
        }
    }
    new ResizeObserver(() => {
        fixScrollHeader()
    }).observe(document.body)
})


